import { Component, OnInit, SimpleChanges, inject } from '@angular/core';

import { MapPlacesGridService } from '../../map-places-grid/map-places-grid.service';
import { PlaceGridLayerData } from '../../map-places-grid/place-grid-layer-data.model';
import { BaseSelectionList } from '../base/base-selection-list.component';

@Component({
    selector: 'map-places-grid-selection-list',
    templateUrl: './map-places-grid-selection-list.component.html',
    standalone: false
})
export class MapPlacesGridSelectionListComponent
  extends BaseSelectionList
  implements OnInit
{
  #mapPlacesGridService = inject(MapPlacesGridService);

  constructor() {
    super();
  }

  ngOnInit() {
    this.initConfig();
    this.getItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items) this.getItems();
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'optionContent';
    if (!this.input_label) this.input_label = '';
  }

  getItems() {
    const items: PlaceGridLayerData[] = this.items;
    this.maxShowItemInDisplay = 1;
    this.items = items.map((item) => ({
      ...item,
      optionContent: this.getOptionContent(item),
    }));
    this.loading = false;
  }

  getOptionContent(item: PlaceGridLayerData): string {
    const optionContent = `
    <div class="tw-flex tw-items-center tw-justify-start">
      <div class="tw-ml-3">
        <i class="mdi mdi-20px ignore-dark-color mdi-star-four-points-small" ></i>
      </div>
      <div>
      <div class="tw-flex tw-flex-row tw-pt-4">
        <div class="fw-bold tw-mb-1 tw-text-[12px]">
          ${item.name}
        </div>
      </div>
          <div class="tw-text-wrap tw-text-[10px] !tw-h-[28px] tw-leading-4" title="${
            item.address
          }">
          <i class="mdi mdi-16px mdi-map-marker-outline tw-text-gray-400 dark:tw-text-slate-300 tw-mx-1"> </i>
                  ${item.address}
          </div>
      </div>
    </div>
    `;
    // const optionContent = `
    // <div class="tw-flex tw-items-center tw-justify-start">
    //   <div class="tw-ml-3">
    //     <i class="mdi mdi-20px ignore-dark-color
    //     ${this.#mapPlacesGridService.getLayerIcon(item.typeId)}" ></i>
    //   </div>
    //   <div>
    //   <div class="tw-flex tw-flex-row">
    //     <div class="fw-bold tw-mb-1 tw-text-[12px]">
    //       ${item.name}
    //     </div>
    //     ${
    //       item.parents.Province
    //         ? `
    //       <div class="tw-font-medium" >
    //       <i class="mdi mdi-16px mdi-home-city-outline tw-text-gray-400 dark:tw-text-slate-300 tw-mx-1"> </i>
    //               ${item.parents.Province}
    //       </div>
    //       `
    //         : ''
    //     }
    //   </div>
    //       <div class="tw-text-wrap tw-text-[10px] !tw-h-[28px] tw-leading-4" title="${
    //         item.address1
    //       }">
    //       <i class="mdi mdi-16px mdi-map-marker-outline tw-text-gray-400 dark:tw-text-slate-300 tw-mx-1"> </i>
    //               ${item.address1}
    //       </div>
    //   </div>
    // </div>
    // `;
    return optionContent || '';
  }
}
// [matTooltip]="item.address1"
